module.exports = __webpack_public_path__ + "fonts/Pretendard-Light.c364fd08.woff";